module.exports = __webpack_public_path__ + "img/couponclass7rc2.ea0807bc.png";